var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accountBindCode"},[_c('TopBar'),_c('WrapManage',{attrs:{"title":"账号—商家编码绑定管理"}},[_c('WrapContent',{attrs:{"smallImg":"","img":_vm.img,"title":"尊敬的商家，若您已与孩子王完成合作，并拥有W商家编码，则无须走线上入驻申请，直接进行W编码绑定即可！"}},[_c('ToBind')],1)],1),_c('FootBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }